
export default {
  name: "EtiquetaPrintEnginePreview",
  props: {
    pdfUrl: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    outdated: {
      type: Boolean,
      default: false,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    maxQuantity: {
      type: Number,
      default: 500,
    },
    warnings: {
      type: Array,
      default: () => [],
    },
    revision: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    generateLabel() {
      return this.pdfUrl ? "Atualizar prévia" : "Gerar prévia";
    },
  },
  methods: {
    changeQuantity(value) {
      const parsed = Number.parseInt(value, 10);
      const next = Math.min(
        this.maxQuantity,
        Math.max(1, Number.isNaN(parsed) ? 1 : parsed)
      );
      this.$emit("update:quantity", next);
    },
  },
};
